export function readClientEnv(name, fallback = '') {
  if (typeof process !== 'undefined' && process.env && process.env[name] !== undefined) {
    return process.env[name];
  }
  return import.meta.env?.[name] ?? fallback;
}
